import { useEffect, useState } from 'react';

/** Whether a media query matches, following the window as it changes. False where there is no matchMedia. */
export function useMediaQuery(q: string): boolean {
  const [hit, setHit] = useState(() => typeof window !== 'undefined' && !!window.matchMedia?.(q)?.matches);
  useEffect(() => {
    const m = window.matchMedia?.(q);
    if (!m) return;
    const on = () => setHit(m.matches);
    on();
    m.addEventListener?.('change', on);
    return () => m.removeEventListener?.('change', on);
  }, [q]);
  return hit;
}

/** Below Tailwind's md (768px): a phone. The shell swaps the sidebar for a drawer, and screens built for preparing
 *  work say so (DesktopOnly); reviewing and approving stay available ("read and approve; prepare on desktop"). */
export const SMALL_SCREEN_QUERY = '(max-width: 767px)';
export const useIsSmallScreen = () => useMediaQuery(SMALL_SCREEN_QUERY);
